import { Paper } from "@mantine/core";
import { warehouseApi } from "apis";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { WarehouseRequestType } from "constants/types/warehouse";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/Warehouse/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import WarehouseFormFields from "../WarehouseFormFields/WarehouseFormFields";
import { createValidationSchema } from "./config";

interface CreateFormProps {
  onClose?: () => void;
  mutate?: () => void;
}

const CreateForm: FC<CreateFormProps> = ({ onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik<WarehouseRequestType>({
    initialValues: {
      code: "",
      name: "",
      type: "",
      description: "",
      isActive: true,
    },
    validationSchema: createValidationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const res = await warehouseApi.create(values);
        if (res.data.success) {
          notification.success({ title: "Tạo nhà kho thành công" });
          onClose?.();
          mutate?.();
          formik.resetForm();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({ title: "Tạo nhà kho thất bại", message: error?.error?.message });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={FORM_IDS.CREATE} onSubmit={formik.handleSubmit}>
          <WarehouseFormFields formik={formik} isCreateMode />
        </form>
      </Paper>
    </Loading>
  );
};

export default CreateForm;
